import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import UploadAvatar from '@/components/layout/uploadImagem/UploadAvatar.vue'
import mensagens from '@/util/mensagens'
import { BToast } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import mascaras from '@/util/mascaras'
import util from '@/util'
import imageStreamUtil from '@/components/layout/imageStream/js/util'

export default {
  name: 'minhaConta',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    UploadAvatar,
    'b-toast': BToast
  },

  computed: {
  },

  data: () => {
    return {
      formulario: {
        f_name: null,
        f_extension: null,
        f_birthday: null,
        f_email: null,
        current_password: null,
        new_password: null,
        confirm_password: null,
        f_photo: []
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      apenasLeitura: true,
      f_photo_usuario: null
    }
  },

  mounted () {
    this.obterRegistro()
  },

  methods: {
    ...mapActions('auth', ['ActionSetCodigoFotoUsuario']),

    async obterRegistro () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/minha-conta')
        this.formulario.f_name = resposta.data.retorno.dados.f_name
        this.formulario.f_extension = resposta.data.retorno.dados.f_extension
        this.formulario.f_birthday = resposta.data.retorno.dados.f_birthday
        this.formulario.f_email = resposta.data.retorno.dados.f_email
        this.f_photo_usuario = resposta.data.retorno.dados.f_photo
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, mensagens.carregandoDadosEdicao)
    },

    async salvarRegistro () {
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

        let dadosFormulario = util.mapearObjetos(this.formulario, {})
        dadosFormulario.f_birthday = util.formatarData(dadosFormulario.f_birthday)

        const formData = this.montarObjetoDeEnvio(dadosFormulario)
        const resposta = await this.axios.post('/minha-conta/salvar', formData)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros

        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    async atualizarFotoUsuario () {
      try {
        if (!util.valorVazio(this.f_photo_usuario)) {
          const codigoBase64 = await imageStreamUtil.obterCodigoBase64DoObjetoStream(this.f_photo_usuario)
          this.ActionSetCodigoFotoUsuario(codigoBase64)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaAtualizarFotoUsuario)
      }
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const fotoUsuario = ['f_photo']
      const camposIgnorados = [...fotoUsuario]

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor)
        }

        if (fotoUsuario.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave + '[]', valor, valor.nome)
        }
      }
      return formData
    },

    async tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        await this.obterRegistro()
        await this.atualizarFotoUsuario()
        this.limparCamposSenha()
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
      this.definirFlagApenasLeitura(true)
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagApenasLeitura (habilitar = true) {
      this.apenasLeitura = habilitar
    },

    limparCamposSenha () {
      this.formulario.current_password = null
      this.formulario.new_password = null
      this.formulario.confirm_password = null
    },

    mascaraTelefoneCelular (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },

    receberDadosUploadAvatar (dadosArquivo) {
      this.formulario.f_photo = []
      this.formulario.f_photo = dadosArquivo
    }
  }
}
